import { render, staticRenderFns } from "./phone-number-form-list.vue?vue&type=template&id=0e0c7774"
import script from "./phone-number-form-list.vue?vue&type=script&lang=js"
export * from "./phone-number-form-list.vue?vue&type=script&lang=js"
import style0 from "./phone-number-form-list.vue?vue&type=style&index=0&id=0e0c7774&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports